 import { useState, useEffect } from 'react';
import { getDiagnostics } from '../../../services/general';

const useDiagnostics = ({ defaultDiagnosticCodes }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [defaultDiagnostics, setDefaultDiagnostics] = useState([]);

  useEffect(() => {
    if (defaultDiagnosticCodes?.length) {
      fetchDefaultDiagnostics(defaultDiagnosticCodes);
    }
  }, [defaultDiagnosticCodes]);

  const fetchDiagnostics = async (query) => {
    try {
      setLoading(true);
      const response = await getDiagnostics(query);
      setData(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDefaultDiagnostics = async (codes) => {
    try {
      setLoading(true);
      const response = await getDiagnostics({ codes: codes.join(',') });
      setDefaultDiagnostics(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return { fetchDiagnostics, loading, data, defaultDiagnostics };
};



export default useDiagnostics;